import { useEffect, useState } from "react";
import { getQaAxiosClient, getQaConfiguration } from "../utils/saludV2Client";

const positiveId = value => ["number", "string"].includes(typeof value) &&
  /^[1-9]\d*$/.test(String(value)) && Number.isSafeInteger(Number(value)) ? Number(value) : null;

export async function getNutriMedicamentos(rawProjectId, { signal } = {}) {
  const projectId = positiveId(rawProjectId);
  if (!projectId) throw new Error("Proyecto de convocatoria no valido.");
  let token;
  try { token = JSON.parse(localStorage.getItem("token") || "null")?.idToken; } catch (_) { /* No usable session. */ }
  if (!token) {
    const error = new Error("Inicie sesion nuevamente.");
    error.status = 401;
    throw error;
  }
  let rows;
  try {
    const response = await getQaAxiosClient(getQaConfiguration()).get("/medicamentos/", {
      params: { codigoProyecto: projectId, sector: 3 }, signal,
      headers: { Authorization: `Bearer ${token}`, "x-access-token": token },
    });
    rows = response.data;
  } catch (error) {
    // The legacy endpoint represents an empty catalog as HTTP 400 with an empty array.
    if (error?.response?.status === 400 && Array.isArray(error.response.data) && error.response.data.length === 0) return [];
    throw error;
  }
  if (!Array.isArray(rows)) throw new Error("Catalogo de medicamentos no disponible.");
  return [...new Set(rows.filter(row => positiveId(row?.codigo_proyecto) === projectId &&
    String(row?.sector) === "3" && positiveId(row?.id_medicamento) &&
    typeof row?.descripcion === "string" && row.descripcion.trim()).map(row => row.descripcion.trim()))];
}

export default function useNutriMedicamentos(context, convocatoriaId, enabled) {
  const projectId = positiveId(context?.projectId);
  const contextId = positiveId(context?.id);
  const scope = enabled && contextId && contextId === positiveId(convocatoriaId) && projectId
    ? `${contextId}:${projectId}` : "";
  const [state, setState] = useState({});
  useEffect(() => {
    if (!scope) return undefined;
    let cancelled = false;
    const controller = new AbortController();
    setState({ scope, options: [], loading: true, ready: false, error: "" });
    getNutriMedicamentos(projectId, { signal: controller.signal }).then(options => {
      if (!cancelled) setState({ scope, options, loading: false, ready: true, error: "" });
    }).catch(error => {
      if (cancelled) return;
      const status = error?.response?.status || error?.status;
      const message = status === 401 ? "Sesion no valida para consultar medicamentos."
        : status === 403 ? "Sin permiso para consultar medicamentos."
          : "No se pudo cargar el catalogo de medicamentos.";
      setState({ scope, options: [], loading: false, ready: false, error: message });
    });
    return () => { cancelled = true; controller.abort(); };
  }, [scope, projectId]);
  return scope && state.scope === scope ? state
    : { options: [], loading: Boolean(scope), ready: false, error: "" };
}
